module.exports = __webpack_public_path__ + "img/5-3.86d49a37.png";